import {
  IPaginatedScheduledNotificationsParams,
  PaginatedScheduledNotificationsResponse,
} from '../components/scheduled-notifications/share-type'
import config from '../config/index'
import { authRequest } from '../request'

const { mainApi } = config

export const getPaginatedScheduledNotifications = (
  params: IPaginatedScheduledNotificationsParams,
) =>
  authRequest.get<MISSING_TYPE, PaginatedScheduledNotificationsResponse>(
    `${mainApi}/scheduled-notifications`,
    {
      params,
    },
  )
